/* eslint-disable import/extensions */
import { Card, Button, Modal } from 'antd';
import { useEffect, useState } from 'react';
import TypeAndQueryCard from '../TypeAndQueryCard';
import QueryBuilderCustomUtils from '../custom_utils/QueryBuilderCustomUtils';
import loadConfig from "../config";
import { EditButton } from '@refinedev/antd';
import { SingleModeProps } from './singleModeType';

const SingleMode = ({ label, value, fields, onSave, handleOnQueryChange, showButtons, showEditor, handleEditMode,editFormula }: SingleModeProps) => {
  const [singleObj, setSingleObj] = useState<any>({
    type: value.type,
    value: value.value,
    query: value.query,
    jsonLogic: value.jsonLogic,
    error:value.error
  });
  const onTypeSave = (data) => {
    setSingleObj(data);
    handleOnQueryChange(data)
  };
  const onSaveHandler = () => {
    onSave({
      sql: singleObj.value,
      json: { ...singleObj },
      jsonLogic: singleObj.jsonLogic,
      error:singleObj.error
    });
  };

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loading) setLoading(false);
  }, [loading]);
  useEffect(() => {
    const finalWhenData = { ...value };
    if (value?.caseList?.length === 0) {
      finalWhenData.caseList = [{ when: '', then: '' }];
    }
    setLoading(true);
  }, [value]);

  const showModal = () => {
    Modal.info({
      title: '',
      width: 1000,
      maskClosable: false,
      content: (
        <div>
          <pre>{singleObj.value}</pre>
        </div>
      ),
      onOk() { },
    });
  };

  const showJsonLogicModal = () => {
    const loadedConfig = loadConfig('antd', fields);
    let jsonLogic = QueryBuilderCustomUtils.getJsonLogic({ ...singleObj }, loadedConfig);
    Modal.info({
      title: '',
      width: 1000,
      maskClosable: false,
      content: (
        <div>
          <pre>{JSON.stringify(jsonLogic, null, 2)}</pre>
        </div>
      ),
      onOk() { },
    });
  };


  console.log(handleEditMode, 'handleEditMode')

  return (
    <>
      {
        showButtons &&
        <div className='flex justify-end single-option-query-btn-group query-btn-group'>
          <Button size='middle' type="default" className="mx-2" key="save" onClick={onSaveHandler}>
            Validate
          </Button>
          <Button size='middle' className="mx-2" type='default' onClick={showModal}>
            Show Query
          </Button>

          <Button size='middle' className="ml-2" type='default' onClick={showJsonLogicModal}>
            Show Json Query
          </Button>
        </div>
      }
      {
        (showEditor === undefined || showEditor) ?
          <div>
            <TypeAndQueryCard
              title=""
              hideType={true}
              onSave={onTypeSave}
              data={singleObj}
              fields={fields}
            />
          </div>
          :
          <div className="flex items-center">
            <div className='mr-2'>
              <span className='font-bold '>{label ? label : ""} </span>
            </div>
            {singleObj?.value ? <pre className='mb-0 whitespace-normal'>{singleObj?.value}</pre> : '-'}
            {editFormula && handleEditMode &&
              <EditButton className='border-0' hideText onClick={() => handleEditMode()}></EditButton>
            }

          </div>
      }





    </>


  );
};

export default SingleMode;
